<template>
  <v-app id="app" pa-0>
    <v-layout  pa-0 v-if="Connected()" justify-space-between  fill-height >
    <!-- <modalWindow></modalWindow> -->
      <mainMenu :items="menuItems"></mainMenu>

      <!-- <message></message> -->
 
    </v-layout >
    <v-layout  v-else class="scan_container" fill-height row>
      <scan ></scan>
    </v-layout>
  </v-app>
</template>
<script>

import Vue from 'vue'
import mainMenu from './components/mainMenu'
import scan from './components/scan'
import {store,loadMenuFromDevice,loadGroupsFromDevice} from './main'
import router from './router'

export default {
  name: 'app',
  components: {
    mainMenu,
    scan    
  },
  data () {
    return {
      //
    }
  },
  beforeMount: function () {
    loadMenuFromDevice()
    // window.menu.init('ddtopmenubar', 'topbar')
  },
  mounted:function()
  {
    // if( window.scrollY < 20 )
    // {
			//reset to hide addr bar at onload
			//scrollTo( 0, 20);
    // }
    
  },
  computed: {
    menuItems: function () {
      return this.$store.getters.getMenu
    }
  },
    watch: {
    '$route' (to, from) {
      store.commit('clearStatusParams')
      // alert('from: ' +JSON.stringify(from.params) + '\r\n' + 'to: ' + JSON.stringify(to.params) + '\r\n' + '$route: ' + this.$route.path)
      if (this.$route.path === '/') 
        this.$route.params.id = 0
      if (typeof(this.$route.params.id) !== 'undefined') 
        loadGroupsFromDevice(this.$route.params.id);
      if (store.getters.getActiveMenu.statusGroups) {
        store.getters.getActiveMenu.statusGroups.forEach(function (group) {

          store.commit('addStatusParams',  group )
        })
      }
    }
  },
  methods: {
    Connected: function () {
      return this.$store.getters.getConnection
    }
  }
}
</script>
